<!--
 * @Author: owen
 * @Date: 2022-03-18 14:11:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-04-12 17:29:11
 * @Description: file content
 * @FilePath: \app-pcweb\src\components\game\hot.vue
-->
<template>
  <div class="hot-box" v-if="pcList.length">
    <h2 class="txt text-h4" style="padding-top: 0px">
      {{ $t("Datalang.HomePage_TYPE_porpular") }}
      <!-- <span class="more" @click="btnCilck('/search/all/all')">
        {{ $t("Datalang.HomePage_BTM_loadmore") }}
        <em class="el-icon-arrow-right"> </em>
      </span>-->

      <i v-if="cur_left > 0" @click="changePosition('left')" class="el-icon-arrow-left"></i>
      <i v-if="cur_left < max_left" @click="changePosition('right')" class="el-icon-arrow-right"></i>
    </h2>
    <div class="hot-content">
      <div v-if="!getIsMobile" class="p-hot-box p-hot-box-slide">
        <template v-for="(item, i) in list">
          <div class="img-box" v-if="hidegd(item)" :key="'pc_' + i" :class="{ 'mr-0': (i + 1) % 6 === 0 }">
            <gameItem :item="item"/>
          </div>
        </template>
      </div>
      <div v-if="getIsMobile" class="p-hot-box p-hot-box-slide">
        <template v-for="(item, i) in list">
          <div class="img-box h5-box" v-if="hidegd(item)" :key="'h5_' + i" :class="{ 'mr-0': (i + 1) % 3 === 0 }">
            <gameItem :item="item"/>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import hHot from "@/lobby_common/mixins_components/game/h-hot.js";
export default {
  components: {},
  props: [],
  mixins: [hHot],
  data() {
    return {};
  },
  filters: {},
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
h2.text-h4 {
  position: relative;
  padding-left: 28px;
}

.text-h4-icon {
  position: absolute;
  left: 0;
  top: 9px;
}

.hot-box {
  display: block;
  overflow: hidden;
  width: 100%;
  padding-bottom: 15px;
  margin-top: 10px;
  position: relative;
  z-index: 9;
}

.txt {
  display: block;
  height: 42px;
  line-height: 42px;
  padding: 12px 0;
  // padding-left: 50px;
  font-size: 16px;
  margin: 0;
  padding-top: 30px;
  overflow: hidden;
  white-space: nowrap;
  /*不换行*/
  text-overflow: ellipsis;

  /*超出部分文字以...显示*/
  .more {
    float: right;
    height: 42px;
    line-height: 42px;
    font-weight: 400;
    font-size: 16px;
    cursor: pointer;
  }
}

.hot-game-list {
  display: block;
  width: 100%;
  height: 164px;
  overflow: scroll;
  overflow-y: hidden;

  .hot-center {
    display: inline-block;
    white-space: nowrap;
    will-change: transform;

    .hot-items {
      position: relative;
      display: inline-block;
      width: 120px;
      overflow: hidden;
      margin-right: 15px;
      font-size: 16px;

      .shiwan-mark {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-size: 12px;
        transform: all ease 0.3s;

        .nomal {
          width: 80%;
          background-color: var(--background-1400);
          color: var(--font-color-100);
          text-align: center;
          padding: 8px 0;
          border-radius: 16px;
          margin-bottom: 16px;

          &.realmode {
            background-color: var(--background-900);
          }
        }

        .shiwan {
          text-decoration: underline;
        }
      }

      &:last-child {
        margin-right: 0px;
      }

      .txt {
        text-align: center;
        height: 36px;
        line-height: 36px;
        padding: 0;
        font-size: 14px;
      }
    }

    .hot-item {
      position: relative;
      display: inline-block;
      width: 120px;
      height: 120px;
      border-radius: 16px;
      border: none;
      overflow: hidden;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.hot-content {
  overflow: hidden;

  @media (max-width: 768px) {
  }
}

.p-hot-box {
  // overflow: hidden;
  position: relative;
  display: flex;

  .img-box {
    position: relative;
    display: inline-block;
    width: 15%;
    // margin: 0 auto;
    padding-top: 12px;
    margin-right: 2%;
    overflow: hidden;
    cursor: pointer;
    transition: 0.5s;
    flex-shrink: 0;

    &.h5-box {
      width: 28%;
      margin-right: 8%;

      & > .txt {
        font-size: 14px;
        height: 42px;
        line-height: 42px;
      }

      &.more-box {
        position: relative;

        & > .txts {
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    &.mr-0 {
      margin-right: 0;
    }

    &:last-child {
      margin-right: 0;
    }

    .txt {
      text-align: center;
      height: 36px;
      line-height: 36px;
    }

    .game-name {
      // height: 48px;
      line-height: 24px;
      margin: 5px 0;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // -webkit-box-orient: vertical;
      box-sizing: border-box;
      // font-weight: bold;
      text-align: center;
      display: flex;
      flex-direction: column;

      .game-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      &.top {
        justify-content: flex-end;
      }

      &.level_show1 {
        .game-text {
          text-align: start;
        }
      }

      &.level_show2 {
        .game-text {
          text-align: center;
        }
      }

      &.level_show3 {
        .game-text {
          text-align: end;
        }
      }
    }

    .game-name-bg {
      &.level_show1 {
        .game-text {
          text-align: start;
        }
      }

      &.level_show2 {
        .game-text {
          text-align: center;
        }
      }

      &.level_show3 {
        .game-text {
          text-align: end;
        }
      }

      &.top {
        top: 0;
        bottom: none;
        transform: rotate(180deg);

        .game-text {
          transform: rotate(180deg);
        }
      }
    }

    &:hover .item-img img {
      // -webkit-transform: translateY(-12px);
      // -moz-transform: translateY(-12px);
      // -ms-transform: translateY(-12px);
      // -o-transform: translateY(-12px);
      // transform: translateY(-12px);
      // transition: all 0.5s;
      // -moz-transition: all 0.5s;
      // -webkit-transition: all 0.5s;
      transform: scale(1.1);
      transition: all ease-in-out 0.5s;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }

  .item-img {
    position: relative;
    width: 100%;
    max-width: 300px;

    ::v-deep img.el-image__inner {
      width: 100%;
    }

    .tag-icon {
      width: auto;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
    }

    .shiwan-mark {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.7);
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 12px;
      transform: all ease 0.3s;

      .nomal {
        width: 80%;
        background-color: var(--background-1400);
        color: var(--font-color-100);
        text-align: center;
        padding: 8px 0;
        border-radius: 16px;
        margin-bottom: 16px;

        &.realmode {
          background-color: var(--background-900);
        }
      }

      .shiwan {
        color: var(--font-color-200);
        text-decoration: underline;
      }
    }

    .collection {
      position: absolute;
      top: 5px;
      right: 5px;
    }

    img {
      width: 100%;
      display: block;
      border-radius: 10px;
      transition: all ease-in-out 0.5s;
    }

    .tubiao {
      position: absolute;
      right: 0px;
      width: 40px;
      height: 35px;
      top: 0px;
      box-sizing: border-box;
      z-index: 999;
    }
  }
}

.el-icon-arrow-left {
  font-size: 24px;
  position: absolute;
  right: 25px;
  top: 20px;
  cursor: pointer;
}

.el-icon-arrow-right {
  font-size: 24px;
  position: absolute;
  right: 0;
  top: 20px;
  cursor: pointer;
}
</style>
